require('../../../libs/backbone/backbone.ajaxq.adapter.ts');
var GenericView = require('views/generic.view.ts');

var Handlebars = require('handlebars');
var HandlebarsHelpers = require('../../../libs/handlebars/handlebars-helpers.ts');

var Template = require('text-loader!templates/checkin/issueTicket.template.html');

var CustomerInfoView = require('views/checkin/customerInfo.view.ts');

require('../../../libs/bootstrap/js/bootstrap-table.js');
var i18n = require("l10n");

var TheView = GenericView.extend({
    el: "#container",
    tagName: 'div',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	initialize: function (options) {
		var self = this;

        this.userData = options ? options.userData : null;
        this.privilegeLevel = this.userData ? this.privilegeLevelToNumber(this.userData.privilegeLevel) : 999;

        this.render();

        // since we have it as `display: flex`, we need it to to have flex in the the beginning,
        // so that when we show it, it will retain the 'display: flex' and not change back to `display: block`
        $("#autocomplete-not-found").hide();
	},
	superRender:  GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

        var templateData = {
            "privilegeLevel": this.privilegeLevel
        }

		this.$el.html(this.template(templateData));

        this.customerInfoView = new CustomerInfoView();
	},
	events: {
        "input #customerCodeSearch": "autoCompleteInput"
	},
	loadData: function(searchText) {
	    var self = this;

	    return $.ajaxDefaultQ({
            url: "rest/api/customers/all?searchText=" + encodeURIComponent(searchText),
            type: 'GET',
        }).done(function(response, status, xhr){

        })
        .fail(function(response) {

        });
	},
	addActive: function(x) {
	    /*a function to classify an item as "active":*/
        if (!x)
            return false;

        /*start by removing the "active" class on all items:*/
        this.removeActive(x);

        if (currentFocus >= x.length)
            currentFocus = 0;
        if (currentFocus < 0)
            currentFocus = (x.length - 1);

        /*add class "autocomplete-active":*/
        x[currentFocus].classList.add("autocomplete-active");
	},
	removeActive: function(x) {
        /*a function to remove the "active" class from all autocomplete items:*/
        for (var i = 0; i < x.length; i++) {
            x[i].classList.remove("autocomplete-active");
        }
    },
    closeAllLists(e) {
        /*close all autocomplete lists in the document,
        except the one passed as an argument:*/
        var x = document.getElementsByClassName("autocomplete-items");

        var elmnt = e ? $(e.currentTarget)[0] : null;

        for (var i = 0; i < x.length; i++) {
            if (elmnt != x[i] && elmnt != $("#customerCodeSearch")[0]) {
                x[i].parentNode.removeChild(x[i]);
            }
        }
    },
	autoCompleteInput: _.debounce(function(e) {
	    /*execute a function when someone writes in the text field:*/
	    var self = this;
	    var elem = $(e.currentTarget)[0];

	    var a, b, i, val = elem.value;

        if (!val || val == "") {
            // close autocomplete list
            self.closeAllLists();

            // hide not found message
            $("#autocomplete-not-found").hide();

            // show/hide customer data
            self.showSelectedCustomerInfo();
            return false;
        }

        $.when(self.loadData(val))
        .then(function(response) {
            self.customers = response.data;

            if(self.customers.length == 0) {
                // close autocomplete list
                self.closeAllLists();

                // show not found message
                $("#autocomplete-not-found").show();

                // show/hide customer data
                self.showSelectedCustomerInfo();
                return;
            }
            else {
                // hide not found message
                $("#autocomplete-not-found").hide();
            }

            /*close any already open lists of autocompleted values*/
            self.closeAllLists();

            var arr = self.getCustomerCodes();

            self.currentFocus = -1;
            /*create a DIV element that will contain the items (values):*/
            a = document.createElement("DIV");
            a.setAttribute("id", elem.id + "autocomplete-list");
            a.setAttribute("class", "autocomplete-items");

            /*append the DIV element as a child of the autocomplete container:*/
            elem.parentNode.appendChild(a);

            /*for each item in the array...*/
            for (i = 0; i < arr.length; i++) {

                /*create a DIV element for each matching element:*/
                b = document.createElement("DIV");

                /*make the matching letters bold:*/
                var toSet = arr[i].replace(val, "<strong>" + val + "</strong>");
                b.innerHTML = toSet;

                /*insert a input field that will hold the current array item's value:*/
                b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";

                /*execute a function when someone clicks on the item value (DIV element):*/
                b.addEventListener("click", function(e) {
                    /*insert the value for the autocomplete text field:*/
                    var value = $(e.currentTarget)[0].getElementsByTagName("input")[0].value;
                    $("#customerCodeSearch")[0].value = value;
                    /*close the list of autocompleted values,
                    (or any other open lists of autocompleted values:*/
                    self.closeAllLists();

                    var foundCustomer = $.grep(self.customers, function(val, key) {
                        return val.customerCode == value;
                    });

                    if(foundCustomer.length == 1) {
                        self.showSelectedCustomerInfo(foundCustomer[0]);
                    }
                    else {
                        console.log("could not find customer");
                    }

                });

                a.appendChild(b);

            }
        });
	}, 250),
    getCustomerCodes: function() {
        var self = this;
        var codes = $.map(self.customers, function(value, index) {
            return value.customerCode;
        });

        return codes.sort(function(one, two) {
            one.length < two.length;
        });
    },
    showSelectedCustomerInfo: function(customer) {
        this.customerInfoView.setCustomerData(customer);
    }
});

module.exports = TheView;